import React from 'react'

const CadUsefulDataContext = React.createContext({})

export default CadUsefulDataContext
